import {MailgunLogTypeEnum} from '@/services/api-clients';

export function mailgunLogTypeIconFilter(type: MailgunLogTypeEnum) {
  switch (type) {
    case MailgunLogTypeEnum.Accepted: return 'mdi-check-all';
    case MailgunLogTypeEnum.Delivered: return 'mdi-send-check';
    case MailgunLogTypeEnum.Failed: return 'mdi-exclamation-thick';
    case MailgunLogTypeEnum.Rejected: return 'mdi-alert-decagram';
    case MailgunLogTypeEnum.Clicked: return 'mdi-cursor-default-click';
    case MailgunLogTypeEnum.Opened: return 'mdi-folder-open';
    case MailgunLogTypeEnum.Stored: return 'mdi-content-save';
    case MailgunLogTypeEnum.Complained: return 'mdi-email-alert';
  }
}
